// Basic translations for American English to Canadian (for now)
export default {
    data() {
        return {
            translations: {
                'en-US': {
                    check: 'check',
                    paycheck: 'paycheck',
                    routing: 'routing',
                    license: 'license',
                    state: 'state',
                },
                'en-CA': {
                    check: 'cheque',
                    paycheck: 'paycheque',
                    routing: 'transit/bank',
                    license: 'licence',
                    state: 'province',
                }
            }
        }
    },
    computed: {
        lang() {
            return navigator.language || 'en-US';
        } 
    },

    methods: {
        translate(phrase, options) {
            let result
            if (this.translations[this.lang] && this.translations[this.lang][phrase]) {
                result = this.translations[this.lang][phrase];
            } else {
                result = phrase;
            }

            if (options) {
                if (options.pluralize) result = this.pluralize(result);
                if (options.capFirst) result = this.capFirst(result);
                if (options.capAll) result = this.capAll(result);
            }
            return result;
        },

        pluralize(string) {
            if (typeof string !== 'string') return string;
            else return string + 's';
        },

        capFirst(string) {
            if (typeof string !== 'string') return string;
            else return string[0].toUpperCase() + string.slice(1);
        },

        capAll(string) {
            if (typeof string !== 'string') return string;
            else return string.toUpperCase();
        },
    }
}
